import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const state = {
  Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
  userInfo: {}
}

const store = new Vuex.Store({

  state,

  mutations: {
    // 修改token，并将token存入localStorage
    changeLogin(state, user) {
      state.Authorization = user.Authorization;
      localStorage.setItem('Authorization', user.Authorization);
      console.log(user)
    },
    SET_USER: (state, info) => {
      state.userInfo = info
    },
  },

  getters: {
    Authorization: state => state.Authorization,
    userInfo: state => state.userInfo,
  }
});

export default store;
